export default __webpack_public_path__ + "images/WK.20d3b6b.png";